'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isLastYear;


// WEBPACK FOOTER //
// ./~/sugar-date/date/isLastYear.js